import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock, Mail, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) {
      toast.success("Welcome back");
      navigate("/admin", { replace: true });
    } else {
      toast.error(res.error || "Login failed");
    }
  };

  return (
    <div className="min-h-[80vh] grid place-items-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="text-center">
          <span className="inline-flex w-12 h-12 rounded-2xl bg-indigo-50 text-indigo-700 items-center justify-center">
            <Lock size={20} />
          </span>
          <h1 className="mt-5 text-3xl font-extrabold text-slate-900 font-display">Admin Portal</h1>
          <p className="mt-2 text-slate-600 text-sm">Sign in with your CareerConnect admin account.</p>
        </div>

        <form onSubmit={submit} data-testid="admin-login-form" className="mt-8 bg-white border border-slate-200 rounded-2xl p-6 lg:p-8 space-y-5 shadow-sm">
          <div>
            <Label className="text-sm font-medium text-slate-800">Email</Label>
            <div className="mt-1.5 relative">
              <Mail size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <Input data-testid="admin-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="pl-9 h-11" placeholder="admin@example.com" />
            </div>
          </div>
          <div>
            <Label className="text-sm font-medium text-slate-800">Password</Label>
            <div className="mt-1.5 relative">
              <Lock size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <Input data-testid="admin-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="pl-9 h-11" placeholder="••••••••" />
            </div>
          </div>
          <Button type="submit" disabled={busy} data-testid="admin-login-submit" className="w-full h-11 rounded-full bg-gradient-to-r from-blue-700 to-indigo-600 hover:from-blue-800 hover:to-indigo-700 text-white font-semibold shadow-md shadow-indigo-500/25">
            {busy ? "Signing in…" : "Sign In"} <ArrowRight size={16} className="ml-2" />
          </Button>
        </form>
      </div>
    </div>
  );
}
